export default __webpack_public_path__ + "static/media/img15.ded8cfc7.png";